import {apiBase} from './ApiBase'
import camelcaseKeys from "camelcase-keys"
import {PaygentFormData, Purchase} from "@/entity/Purchase";

export const newPurchase = async ({price, cardId, item = 'subscription'}) => {
  const result = await apiBase.post(`/newPurchase/${cardId}/${item}`, { price })
  return new PaygentFormData(camelcaseKeys(result.data.data, { deep: true }))
}

export const commitPurchase = async ({ id }) => {
  const result = await apiBase.post(`/trade/${id}`, { })
  return new Purchase(camelcaseKeys(result.data.data, { deep: true }))
}
